/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  VwbDataCollectionListResponse,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    VwbDataCollectionListResponseFromJSON,
    VwbDataCollectionListResponseToJSON,
} from '../models';

/**
 * 
 */
export class VwbDataCollectionAdminApi extends runtime.BaseAPI {

    /**
     * Lists all VWB data collections with their resources. Requires RESEARCHER_DATA_VIEW authority.
     */
    async listVwbDataCollectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VwbDataCollectionListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/data-collections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VwbDataCollectionListResponseFromJSON(jsonValue));
    }

    /**
     * Lists all VWB data collections with their resources. Requires RESEARCHER_DATA_VIEW authority.
     */
    async listVwbDataCollections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VwbDataCollectionListResponse> {
        const response = await this.listVwbDataCollectionsRaw(initOverrides);
        return await response.value();
    }

}
